import React from "react";
import { connect } from "react-redux";
import { fetchCollections } from "../../queries/collections/collectionQuery";
import language from "../../language";
import handleSearch from "../../utils/handleSearch";
import { Table } from "../Table";
import { Modal } from "../Modal";
import icons from "../../constants/icons";
import NewInvoice from "./NewInvoice";

let copyData = [];

class Invoices extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage } = this.props;
    try {
      this.setState({ isLoading });

      const data = [];
      //  await fetchCollections(defaultLanguage);

      this.setState({
        isLoading: false,
        data,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  handleShowModal(modal, modalTitle, selected_data = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selected_data,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].invoice_number,
        key: "invoice_number",
        type: "link",
        onPress: (item) =>
          (window.location.href =
            "/merchant/invoice/?invoiceNumber=" + item.invoiceNumber),
      },

      {
        title: language[this.props.defaultLanguage].date_issued,
        key: "invoiceDate",
      },
      {
        title: language[this.props.defaultLanguage].customer_name,
        key: "clientName",
      },
      {
        title: language[this.props.defaultLanguage].customer_email,
        key: "customerEmail",
      },
      {
        title: language[this.props.defaultLanguage].customer_phone,
        key: "customerPhoneNumber",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
      },
      {
        title: language[this.props.defaultLanguage].actions,
        key: "multiple-actions",
        actions: [
          {
            icon: icons.eye_on,
            title: language[this.props.defaultLanguage].view,
            onPress: (item) =>
              (window.location.href = "/merchant/invoice?invoiceId=" + item.id),
          },
        ],
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].create_invoice}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          handleAddPressed={this.handleShowModal.bind(
            this,
            "showModal",
            language[this.props.defaultLanguage].invoice
          )}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, { copyData, value: e.target.value })
          }
        />
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
          size="lg"
        >
          <NewInvoice
            handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            getData={this.getData.bind(this)}
            {...this.state.selected_data}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Invoices);
